export class PatientContactPreferences {
    active: boolean;
    contactType: string;
    contactTypeId: number;
    contactValue: string;
    id: number;
    isCallAllowed: boolean;
    isPreferred: boolean;
    isTextAllowed: boolean;
    patientId: number;
}
